// @ts-ignore
import {type Oidc} from "@webowski/nuxt-openid-connect/dist/runtime/plugin";

export const useProfile = (): Oidc => {
  const config = useRuntimeConfig()
  const oidc = useOidc()

  // OIDC může být undefined při inicializaci aplikace (před načtením pluginu)
  const safeOidc = oidc ?? {
    user: undefined,
    isLoading: false,
    getState: () => ({}),
    isLoggedIn: false,
    setLoading: () => {},
    setUser: () => {},
    fetchUser: async () => {},
    login: () => {},
    logout: () => {},
  }

  return {
    get user(): any {
      return safeOidc.user
    },
    get isLoading(): any {
      return safeOidc.isLoading
    },
    get getState(): any {
      return safeOidc.getState
    },
    get isLoggedIn(): boolean {
      return safeOidc.isLoggedIn
    },
    setLoading: (loading: boolean): void => {
      safeOidc.setLoading(loading)
    },
    setUser: (user: any): void => {
      safeOidc.setUser(user)
    },
    fetchUser: (): Promise<void> => {
      return safeOidc.fetchUser()
    },
    login: (redirect?: string): void => {
      safeOidc.login(redirect)
    },
    logout: (): void => {
      if (safeOidc.isLoggedIn) {
        // remove uuid cookie when logout
        const userUuid = useCookie(config.public.uuidCookieName)
        userUuid.value = null
        safeOidc.logout()
      }
    },
  }
}

//   return {
//     get user(): any {
//       return oidc.user
//     },
//     get isLoading(): any {
//       return oidc.isLoading
//     },
//     get getState(): any {
//       return oidc.getState
//     },
//     get isLoggedIn(): boolean {
//       return oidc.isLoggedIn
//     },
//     setLoading: (loading: boolean): void => {
//       oidc.setLoading(loading)
//     },
//     setUser: (user: any): void => {
//       oidc.setUser(user)
//     },
//     fetchUser: (): Promise<void> => {
//       return oidc.fetchUser()
//     },
//     login: (redirect?: string): void => {
//       oidc.login(redirect)
//     },
//     logout: (): void => {
//       if (oidc.isLoggedIn) {
//         // remove uuid cookie when logout
//         const userUuid = useCookie(config.public.uuidCookieName)
//         userUuid.value = null
//         oidc.logout()
//       }
//     },
//   }
// }